{
    "welcome-to": "Bienvenue à",
    "copyright": "Copyright",
    "trademarks": "Toutes les marques ou marques déposées sont la propriété de leurs propriétaires respectifs.",

    "menu-profile": "Profil",
    "menu-logout": "Déconnexion",
    "menu-home": "Accueil",
    "menu-dashboard": "Tableau de bord",
    "menu-machines": "Machines",
    "menu-colaboration": "Collaboration",
    "menu-administration": "Administration",
    "menu-machine": "Machine",
    "menu-list": "Liste",
    "menu-service-data": "Données de service",
    "menu-trash": "Corbeille",

    "machine-info": "Informations sur la machine",
    "medium": "Moyen",
    "machine-activity": "Activité de la machine",
    "machine-part-info": "Informations sur la pièce de la machine",
    "name": "Nom",
    "version": "Version",
    "owner": "Propriétaire",
    "state": "État",
    "actions": "Actions",
    "kind": "Type",
    "description": "Description",
    "size": "Taille",
    "last-write": "Dernière modification",
    "ver": "Ver.",
    "restore": "Restaurer",
    "when": "Quand",
    "type": "Type",
    "level": "Niveau",
    "text": "Texte",
    "tags": "Étiquettes",
    "part-type": "Type de pièce",
    "firmware-version": "Version du firmware",
    "model": "Modèle",
    "created": "Créé",
    "modified": "Modifié",
    "status": "Statut",
    "loading": "Chargement",
    "fv": "V.f.",
    "remove": "Supprimer",
    "user": "Utilisateur",
    "fenix-version": "Version Fenix",
    "service-data-remove-question": "Êtes-vous sûr de vouloir supprimer ces données de service ?",
    "save-as-duplicate": "Enregistrer comme doublon",
    "upload-file": "Télécharger un fichier",
    "restore-machine-data-from-backup": "Restaurer les données de la machine à partir de la sauvegarde",
    "you-want-to-change-owner": "Voulez-vous changer de propriétaire ?",
    "choose-file": "Choisir un fichier",
    "detail": "Détail",
    "yes": "Oui",
    "no": "Non",
    "machine-detail-remove-question": "Êtes-vous sûr de vouloir supprimer cette machine ?",
    "status-auto-update": "Mise à jour automatique du statut",
    "download": "Télécharger",
    "copy": "Copier",
    "move": "Déplacer",
    "change-owner": "Changer de propriétaire",
    "new-machine-name": "Nouveau nom de la machine",
    "submit": "Soumettre",
    "set-as-current": "Définir comme actuel",
    "checkout": "Paiement",
    "base-data": "Données de base",
    "part-structure-type": "Type de structure de la pièce",
    "owner-id": "ID du propriétaire",
    "parent-id": "ID parent",
    "part-class-type": "Type de classe de la pièce",
    "errors": "Erreurs",
    "generic-device": "Appareil générique",
    "device-model": "Modèle de l'appareil",
    "address": "Adresse",
    "camera-info": "Informations sur la caméra",
    "sensor-model": "Modèle du capteur",
    "slides-in-view": "Diapositives en vue",
    "slider-info": "Informations sur le curseur",
    "channels": "Canaux",
    "shot-stats-from": "Statistiques de tir de",
    "shot-stats-to": "Statistiques de tir à",
    "shot-stats-counter": "Compteur de statistiques de tir",
    "shot-stats": "Statistiques de tir",
    "slider": "Curseur",
    "valve": "Valve",
    "number-shots": "Nombre de tirs",
    "custom": "Personnalisé",
    "move-machine": "Déplacer la machine",
    "machine-is-not-selected": "Machine non sélectionnée.",
    "machine-successfully-deleted": "Machine supprimée avec succès.",
    "failed-to-delete-machine": "Échec de la suppression de la machine.",
    "failed-to-backup-machine": "Échec de la sauvegarde de la machine.",
    "owner-successfully-changed": "Propriétaire changé avec succès.",
    "failed-to-change-owner": "Échec du changement de propriétaire.",
    "machine-successfully-copied": "Machine copiée avec succès.",
    "failed-to-copy-machine": "Échec de la copie de la machine.",
    "machine-successfully-moved": "Machine déplacée avec succès.",
    "failed-to-move-machine": "Échec du déplacement de la machine.",
    "machine-set-as-current": "Machine définie comme actuelle.",
    "install-app-question": "Souhaitez-vous installer l'application 3U Vision Cloud ?",
    "install": "Installer",
    "cancel": "Annuler",
    "install-application": "Installer l'application",
    "step": "Étape",
    "tap-share-icon": "Appuyez sur l'icône de partage.",
    "scroll-down-and-tap": "Dans le menu de partage, faites défiler vers le bas et appuyez sur",
    "add-to-home-screen": "Ajouter à l'écran d'accueil",
    "you-will-be-propted": "On vous demandera de nommer l'application. Vous pouvez garder le nom par défaut ou le changer comme vous le souhaitez. Ensuite, appuyez sur",
    "add": "Ajouter",
    "in-top-right-corner": "dans le coin supérieur droit",
    "do-not-show-again": "Ne plus afficher",
    "you-are-offline": "Vous êtes hors ligne.",
    "app-can-not-work-offline": "L'application ne peut pas fonctionner hors ligne.",
    "please-check-your-internet-connection": "Veuillez vérifier votre connexion Internet.",
    "unexpected-server-version": "Version inattendue du serveur.",
    "current-is": "L'actuelle est",
    "and-expected": "et attendue",
    "application-version-is": "La version de l'application est",
    "new-version-available": "Nouvelle version disponible",
    "do-you-want-to-install": "Voulez-vous l'installer ?",
    "delete-confirmation": "Confirmation de suppression",
    "machine-medium-remove-question": "Êtes-vous sûr de vouloir supprimer le support ?",
    "machine-medium-checkout-error": "Échec du retrait du support de la machine.",
    "invalid-data": "Données non valides.",
    "failed-to-load-messages": "Échec du chargement des messages.",
    "failed-to-save-board": "Échec de l'enregistrement du tableau.",
    "failed-to-delete-board": "Échec de la suppression du tableau.",
    "machines-upload-file-upload-in-progress": "Téléchargement de fichier en cours.",
    "upload-success": "Téléchargement réussi.",
    "machine-structure-caption": "Structure",
    "machine-structure-value-caption": "Valeur",
    "machine-structure-not-available" : "La structure de la machine n'est pas disponible"
  }
